var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioMic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audio/mic/Solid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3572 16.0714C20.3572 19.0301 17.9587 21.4285 15 21.4285C12.0414 21.4285 9.64289 19.0301 9.64289 16.0714V7.49997C9.64289 4.5413 12.0414 2.14282 15 2.14282C17.9587 2.14282 20.3572 4.5413 20.3572 7.49997V16.0714ZM22.5 11.7857C22.5 11.1939 22.9797 10.7143 23.5715 10.7143C24.1632 10.7143 24.6429 11.1939 24.6429 11.7857V16.0714C24.6362 20.9792 20.9483 25.1009 16.0715 25.651V27.8571H13.9286V25.651C9.05174 25.1009 5.36383 20.9792 5.35718 16.0714V11.7857C5.35718 11.1939 5.83687 10.7143 6.42861 10.7143C7.02034 10.7143 7.50003 11.1939 7.50003 11.7857V16.0714C7.50003 20.2135 10.8579 23.5714 15 23.5714C19.1422 23.5714 22.5 20.2135 22.5 16.0714V11.7857Z",
    fill: "#646B74"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioMic);
export default __webpack_public_path__ + "static/media/audio_mic.b866fec8f300873a222403ac8fb34bab.svg";
export { ForwardRef as ReactComponent };